import {
    NinchatActionType,
    NinchatResetIdentityAuthAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const resetIdentityAuth = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatResetIdentityAuthAction}`,
    async (arg: NinchatActionParams<NinchatResetIdentityAuthAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatResetIdentityAuthAction

        try {
            return await ninchatClient.call(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
